package fr.manyverse.app

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import fr.manyverse.app.infrastructure.monitoring.initMonitoring
import kotlinx.browser.window

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initMonitoring(isDebugBuild = window.location.hostname == "localhost")

    // Aucun fallback de police à enregistrer ici : depuis Compose Multiplatform 1.12.0 le web
    // télécharge à la demande le sous-ensemble Noto couvrant les caractères absents de la police
    // principale (emojis inclus), puis recompose le texte. Le fallback dépend donc du réseau et
    // un bref tofu peut apparaître au premier rendu — c'est le compromis accepté en échange des
    // 10 Mo de NotoColorEmoji qui étaient auparavant embarqués dans *toutes* les cibles.
    ComposeViewport {
        App()
    }
}
